"use client"

import { useEffect, useState } from "react"
import { urlDenganVersi } from "@/modules/media/domain/aset"
import { IlustrasiBawaan } from "./ilustrasi-bawaan"
import { useAsetMedia } from "./media-provider"
import { cn } from "@/shared/lib/utils"
import type { KunciSlot } from "@/modules/media/domain/slot"

interface IlustrasiSlotProps {
  kunci: KunciSlot
  alt?: string
  className?: string
  prioritas?: boolean
}

export function IlustrasiSlot({ kunci, alt = "", className, prioritas = false }: IlustrasiSlotProps) {
  const aset = useAsetMedia(kunci)
  const [gagal, setGagal] = useState(false)

  useEffect(() => setGagal(false), [aset?.url])

  if (!aset || gagal) return <IlustrasiBawaan kunci={kunci} className={className} />

  return (
    <img
      src={urlDenganVersi(aset)}
      alt={alt}
      width={aset.lebar}
      height={aset.tinggi}
      loading={prioritas ? "eager" : "lazy"}
      fetchPriority={prioritas ? "high" : "auto"}
      decoding="async"
      onError={() => setGagal(true)}
      className={cn("mx-auto h-auto w-full max-w-sm object-contain", className)}
    />
  )
}
